// ----------------------------------------------------------------------------
// Extension: product-form--subscriber-message
// ----------------------------------------------------------------------------
// Shows the "Already a subscriber?" message only when the one-time purchase
// option is selected. Listens for productForm:sellingPlanInput:changed.
// ----------------------------------------------------------------------------

import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
iamotaEventHandler.subscribe('productForm:init', _ref => {
  var iamForm = _ref.iamForm;
  var updateMessage = sellingPlan => {
    var msg = iamForm.querySelector('.product__subscriber-message--one-time-only');
    if (!msg) return;
    msg.classList.toggle('is-hidden', (sellingPlan === null || sellingPlan === void 0 ? void 0 : sellingPlan.purchase_type) !== 'onetime');
  };
  var handler = eventData => {
    var _eventData$_options;
    var sellingPlanInput = (_eventData$_options = eventData._options) === null || _eventData$_options === void 0 ? void 0 : _eventData$_options.context;
    if (!sellingPlanInput || !iamForm.contains(sellingPlanInput)) return;
    updateMessage(eventData.sellingPlan);
  };
  iamotaEventHandler.subscribe('productForm:sellingPlanInput:changed', handler);
  var sellingPlanInput = iamForm.querySelector('iam-selling-plan-input');
  if (sellingPlanInput !== null && sellingPlanInput !== void 0 && sellingPlanInput.getCurrentSellingPlan) {
    updateMessage(sellingPlanInput.getCurrentSellingPlan());
  }
}, {
  priority: 1
});